export default __webpack_public_path__ + "static/digital-risk-protection-stack-2a2dd13a7b6674e1e881a314b32ee8f0.jpg";